import React from 'react';
import PropTypes from 'prop-types';
import { SERVICE_TYPES } from '@bagonboard/wiseman';

import { ButtonDetails, Container } from './style';
import { historyPropTypes } from '../../../../../types';

const {
  CHECKIN, SKIP_BAGGAGE_CLAIM, TRANSFER,
} = SERVICE_TYPES;

const needsFlight = ({ type }) => [CHECKIN, SKIP_BAGGAGE_CLAIM].includes(type);
const hasFlightNumber = ({ flightInfo }) => flightInfo && flightInfo.flightNumber;

const hasTerminalNumber = ({ terminal }) => terminal && terminal.number;
const hasFlightTerminal = ({ type, flightInfo }) => (flightInfo
  && hasTerminalNumber(
    [CHECKIN, TRANSFER].includes(type)
      ? flightInfo.origin
      : flightInfo.destination
  )
);

const Details = ({ history, original, value }) => {
  const onDetailsClick = () => {
    const servicePath = 'service';
    history.push(`/${servicePath}/${value}`);
  };

  const isForReview = (
    needsFlight(original)
    && !hasFlightNumber(original))
    || !hasFlightTerminal(original);

  return (
    <Container>
      <ButtonDetails
        isForReview={isForReview}
        onClick={onDetailsClick}
        variant="outlined"
      >
        {isForReview ? 'REVIEW' : 'DETAILS'}
      </ButtonDetails>
    </Container>
  );
};

Details.propTypes = {
  history : historyPropTypes.isRequired,
  original: PropTypes.shape({
    flightInfo: PropTypes.shape({
      flightNumber: PropTypes.string,
    }),
    type: PropTypes.string,
  }),
  value: PropTypes.string,
};

Details.defaultProps = {
  original: {},
  value   : '',
};

export default Details;
